export const form = {
    labels: {
        add_form: "Add Form",
    },
    texts: {
        edit_form: "Edit Form",
        del_form: "Delete Form",
        del_confirm: "Do you want to delete the Form <strong>'{concat}'</strong>?",
        del_method: "Do you want to delete the Method <strong>'{concat}'</strong>?",
        empty_method: "You didn't add a Method to Form!",
    },
};
